import { axiosInstance } from "../App";
import type { AxiosError } from "axios";
import { NomenclatorCodeDTO } from "../interface/interface";
import { GetItemsProps } from "@medere/medere-ui-framework";

export async function getNomenclatorCodes({filterValue, pageSize, offSet, params}:GetItemsProps) {
  
  if (!params.nomenclatorsourceid) return [];
  const normalizedFilter = (filterValue ?? "").trim();
  const sourceId = Number(params?.nomenclatorsourceid ?? 0);
  const endpoint =
    sourceId === 1
      ? "/api/secured/nomenclator/nbu"
      : sourceId === 2
        ? "/api/secured/nomenclator/snomed"
        : "/api/secured/nomenclator";

  const qp = {
    offset: offSet ?? 0,
    pagesize: pageSize ?? 20,
    filter: normalizedFilter || undefined,
    categoryid: params.categoryid ?? undefined,
    nomenclatorsourceid: params.nomenclatorsourceid,
    patientId: params.patientId ?? undefined,
    healthPatientCoverageId: params.healthPatientCoverageId ?? undefined,
  };

  console.log("[getNomenclatorCodes] REQUEST", {
    url: endpoint,
    params: qp,
  });

  try {
    const res = await axiosInstance.get<NomenclatorCodeDTO[]>(
      endpoint,
      { params: qp }
    );

    console.log("[getNomenclatorCodes] RESPONSE", {
      status: res.status,
      len: Array.isArray(res.data) ? res.data.length : 0,
    });

    return res.data ?? [];
  } catch (err) {
    const e = err as AxiosError<any>;
    console.log("[getNomenclatorCodes] ERROR", {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
      config: { url: e.config?.url, params: e.config?.params },
    });
    throw err;
  }
}
